import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Plan";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Route = (options) => GENERATE_URL(`${PREFIX_URL}/Route`, options);

export const PlansByCustomer = (options) =>
  GENERATE_URL(`${PREFIX_URL}/PlansByCustomer`, options);

export const PlanyByEmployee = (options) =>
  GENERATE_URL(`${PREFIX_URL}/PlanyByEmployee`, options);

/** @deprecated API yazımı; yeni kod `PlansByEmployee` kullanır */
export const PlansByEmployee = PlanyByEmployee;

export const GetMonthlyPlansByEmployee = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetMonthlyPlansByEmployee`, options);

export const GetLastPlanWithEmployee = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetLastPlanWithEmployee`, options);

export const GetAllWithPlanDate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAllWithPlanDate`, options);

export const ChangeOrders = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ChangeOrders`, options);

export const ByLocation = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ByLocation`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Route,
  GetLastPlanWithEmployee,
  GetMonthlyPlansByEmployee,
  PlansByCustomer,
  PlanyByEmployee,
  PlansByEmployee,
  GetAllWithPlanDate,
  ChangeOrders,
  ByLocation,
};
